<footer class="footer-emerj noPrint">
  <h3 class="title">
    ESCOLA DA MAGISTRATURA DO ESTADO DO RIO DE JANEIRO - EMERJ
  </h3>
  <p class="dados">
    Endereço: Rua Dom Manuel, nº 25 - Centro - CEP 20010-090 - Telefone: (21) 3133-2682
    <br />Este site foi desenvolvido para ser melhor visualizado em resolução de 1024x768 no Internet Explorer 9+
  </p>
</footer>
